<script setup lang="ts">
// PROPS
defineProps({
    title: { type: String, default: '' },
    description: { type: String, default: '' },
});
</script>

<template>
    <BaseWidthContainer class="space-y-8">
        <h2 v-if="$slots.title || !!title" class="text-primary-800 text-center text-3xl font-semibold">
            <slot name="title">{{ title }}</slot>
        </h2>
        <div v-if="$slots.description || !!description" class="text-base">
            <slot name="description">{{ description }}</slot>
        </div>
        <slot />
    </BaseWidthContainer>
</template>
